import * as P from 'prop-types';
import { DefectsProps } from '@redux/reducers/NewRepairReducer/PropTypes';

const propTypes = {
  defects: P.arrayOf(P.shape(DefectsProps)),
  hookCalcBudget: P.func.isRequired,
  openRefuseBudget: P.func.isRequired,
  selectedDefects: P.arrayOf(P.shape(DefectsProps)),
};

export default {
  propTypes,
  defaultProps: {},
};
